import React from 'react';
import './animate2.less';

const Animate2: React.FC = () => {
    return <div className="c-animate2"></div>;
};

export default Animate2;
